var screenWidth = window.innerWidth

var adWidth = Math.round(screenWidth * 0.5)
var adHeight = Math.round(adWidth * 2 / 3)

console.log(adWidth, adHeight)

var adElement = document.querySelector('.left-bottom-float-fullScreenSleep');
if(adElement) {
    adElement.style.width = adWidth + "px";
    adElement.style.height = adHeight + "px";
    adElement.style.marginLeft = "-" + adWidth / 2 + "px";
}

var containerElement = document.querySelector('.left-bottom-float-fullScreenSleepContainer');
if(containerElement) {
    containerElement.addEventListener('click', function (event) {
        adElement.style.display = 'none';
        containerElement.style.display = 'none';
    });
}

var fullScreenSleep = function () {
    if(adElement) adElement.style.display = 'block';
    if(containerElement) containerElement.style.display = 'block';
    window.addEventListener('scroll', function () {
        console.log("fullScreenSleep scroll");
        if(adElement) adElement.style.display = 'none';
        if(containerElement) containerElement.style.display = 'none';
    });
};

export default fullScreenSleep